import React from 'react';
import BaseModal from '../../modals/BaseModal';
import { connect } from 'react-redux';
import { setDashboardParams } from '../../../../store/actions';
import moment from 'moment';
import RowCard from '../../../cards/rowCard';

class DoorCanvassPassSelectionModal extends React.Component {
  constructor(props) {
    super(props);

    this.DISPLAY_FORMAT = 'YYYY-MM-DD';
  }

  handleSelection = (pass) => {
    this.props.setDashboardParams({
      selectedOffice: pass.canvass.office,
      selectedDoorCanvassPass: pass.id,
    });
    this.props.afterSelect && this.props.afterSelect(pass.id);
  };

  render() {
    return (
      <BaseModal
        title={'Please select a doorcanvass pass.'}
        {...this.props}
        center
        showCloseIcon={true}
      >
        {this.props.doorCanvassPasses.map((pass) => {
          return (
            <RowCard
              className={'clickable'}
              onClick={() => this.handleSelection(pass)}
              expanded={true}
              key={btoa(`${pass.id}`)}
              color={'#9b4dca'}
              columns={[
                {
                  title: 'Pass',
                  text: pass.name,
                  textStyle: {
                    fontWeight: 'bold',
                    borderBottom: `2px solid ${pass.hex_color}`,
                    fontSize: '16px',
                  },
                  columnWidth: 33,
                },
                {
                  title: 'Created',
                  text: `${new moment(pass.created_at).format(this.DISPLAY_FORMAT)}`,
                  columnWidth: 20,
                },
              ]}
            />
          );
        })}
      </BaseModal>
    );
  }
}

const mapStateToProps = (state) => ({
  doorCanvasses: state.doorCanvasses.data,
  doorCanvassPasses: state.doorCanvassPasses.data,
  selectedDoorCanvassPass: state.dashboardParams.selectedDoorCanvassPass,
  selectedOffice: state.dashboardParams.selectedOffice,
});

const mapDispatchToProps = (dispatch) => ({
  setDashboardParams: (data) => dispatch(setDashboardParams(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DoorCanvassPassSelectionModal);
